<script setup lang="ts">
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

type IncludedList = CrystallizeProduct['components']['includedList']

type IncludedText = CrystallizeProduct['components']['includedText']

defineProps<{ list: IncludedList, text: IncludedText, highlighted: boolean }>()
</script>

<template>
  <ContentGrid class="gap-y-l items-center">
    <div class="flex flex-col col-span-4 2xl:col-span-6 2xl:col-start-2" :class="{ 'text-white': highlighted }">
      <h3 class="mb-xl pt-2.5xs">
        Dette er inkludert
      </h3>
      <ul v-if="list?.length" class="grid grid-cols-1 sm:grid-cols-2 gap-m mb-m pb-2.5xs">
        <li v-for="(item, key) in list" :key="key" class="flex items-center gap-s">
          <Shape variant="hexagon" class="w-10.5" :icon="faCheck" :class="highlighted ? 'fill-moss-100 text-moss-300' : 'fill-blurple-300 text-white'" />
          <span v-text="item.text" />
        </li>
      </ul>
      <template v-if="text">
        <CrystallizeRichText v-for="(block, key) in text" :key="key" :block="block" />
      </template>
    </div>
    <slot />
  </ContentGrid>
</template>
